import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { useStore } from "vuex";
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}
const pdfPrinter = () => {
    const store = useStore();
    const {getHeader, getFooter} = pdfHeaderFooter();

    const userName = store.state.user.user.name;

    const exportToPDF = (company, attendanceData, totalExpenseClaim) => {
        var doc = {
            pageSize: 'A4',
            pageMargins: [30, 100, 30, 80],
            header: getHeader(company),
            footer: getFooter(userName),
            content: getContent(attendanceData, totalExpenseClaim),

            styles: {
                header: {
                    fontSize: 20,
                }
            },

            defaultStyle: {
                color: 'black',
                fontSize: 11,
                font: 'SulaimanLipi'
            },

            info: {
                title: 'My Attendance'
            }
        }

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    const getContent = (attendanceData, totalExpenseClaim) => {
        return [
            {
                text: 'My Attendance',
                style: 'header',
                alignment: 'center',
                fontSize: 11,
                decoration: 'underline',
                margin: [0, 0, 0, 10],
                bold: true,
            },
            {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    widths: ['15%', '37%', '10%', '10%', '8%', '10%', '10%'],
                    headerRows: 1,
                    body: [
                        [
                            { text: 'Date | Day', style: 'tableHeader' },
                            { text: 'Location', style: 'tableHeader' },
                            { text: 'In Time', style: 'tableHeader' },
                            { text: 'Out Time', style: 'tableHeader' },
                            { text: 'Status', style: 'tableHeader' },
                            { text: 'Expense Claim', style: 'tableHeader', alignment: 'right' },
                            { text: 'Approval Status', style: 'tableHeader' },
                        ],
                        ...getRows(attendanceData),
                        [
                            { text: 'Total', colSpan: 5, bold: true },
                            {}, {}, {}, {},
                            { text: getAmount(totalExpenseClaim), bold: true, alignment: 'right' },
                            '',
                        ]
                    ]
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function (i, node) {
                        return 0.5;
                    },
                    vLineWidth: function (i, node) {
                        return 0.5;
                    }
                }
            }
        ];
    };

    const getRows = (attendanceData) => {
        return attendanceData.map(function (item) {
            return [
                item.format_calendar_date_year + ' | ' + item.day,
                getLocation(item.attendance_locations),
                getValue(item.in_time),
                getValue(item.out_time),
                getValue(item.status),
                { text: getAmount(item.expense_claim), alignment: 'right' },
                getValue(item.approval_status),
            ];
        });
    }

    const getValue = (value) => {
        if (empty(value)) return '';
        return value;
    }

    const getLocation = (value) => {
        if (empty(value)) return '';
        const uniqueLocations = [...new Set(value.split(' | '))];
        return uniqueLocations.join(' | ');
    }

    const empty = (value) => {
        if (value === null || value === undefined) return true;
        return value === '';
    }

    const getAmount = (value) => {
        if (empty(value)) return 0;
        return value;
    }

    return {
        exportToPDF
    }
}

export default pdfPrinter;
